// Auto-generated by backend/generate_murottal.py — Murottal player labels (11 languages).
export const MUROTTAL_UI = {
  "title": {
    "id": "Murottal Al-Qur'an 30 Juz",
    "en": "Murottal of the Qur'an – 30 Juz",
    "ar": "مرتّل القرآن الكريم – 30 جزءاً",
    "fr": "Murottal du Coran – 30 Juz",
    "de": "Murottal des Korans – 30 Juz",
    "es": "Murottal del Corán – 30 Juz",
    "ru": "Муроттал Корана – 30 Джузов",
    "zh": "《古兰经》全本诵读 — 30 篇",
    "ja": "クルアーン朗読（全30ジュズ）",
    "ko": "꾸란 무로딸 – 30 주즈",
    "hi": "क़ुरआन मुरत्तल – 30 जुज़"
  },
  "reciter": {
    "id": "Qari: Syaikh Khalifa Al Tunaiji (riwayat Hafs 'an 'Ashim)",
    "en": "Reciter: Shaykh Khalifa Al-Tunaiji (narration of Hafs 'an 'Asim)",
    "ar": "القارئ: الشيخ خليفة الطنيجي (رواية حفص عن عاصم)",
    "fr": "Récitateur : Cheikh Khalifa Al-Tunaiji (narration de Hafs 'an 'Asim)",
    "de": "Rezitator: Scheich Khalifa Al-Tunaiji (Überlieferung von Hafs 'an 'Asim)",
    "es": "Recitador: Jeque Khalifa Al-Tunaiji (narración de Hafs 'an 'Asim)",
    "ru": "Чтец: Шейх Халифа Аль-Тунайджи (риваят Хафс 'ан 'Асим)",
    "zh": "诵读者：谢赫·哈利法·图奈基（哈福斯传述阿西姆读法）",
    "ja": "朗読者：シャイフ・ハリーファ・アル＝トゥナイジー（ハフス・アン・アースィム伝承）",
    "ko": "낭독자: 샤이흐 할리파 알-투나이지 (하프스 '안 아심 전승)",
    "hi": "क़ारी: शैख़ ख़लीफ़ा अल-तुनैजी (हफ़्स 'अन 'आसिम की रिवायत)"
  },
  "desc": {
    "id": "Pemutar berurutan otomatis — ayat demi ayat, surah demi surah hingga 114 surah, tanpa perlu menekan tombol putar di setiap ayat. Ayat yang sedang dibaca disorot dan halaman bergulir mengikuti bacaan.",
    "en": "Automatic sequential player — verse by verse, surah by surah through all 114 surahs, without needing to press play on each verse. The verse currently being recited is highlighted and the page scrolls along with the recitation.",
    "ar": "مشغّل تسلسلي تلقائي — آية بعد آية، وسورة بعد سورة حتى تكتمل 114 سورة، دون الحاجة إلى الضغط على زر التشغيل عند كل آية. تُظلَّل الآية التي يجري تلاوتها وتتمرر الصفحة تلقائياً مع التلاوة.",
    "fr": "Lecteur séquentiel automatique — verset par verset, sourate par sourate jusqu'aux 114 sourates, sans avoir besoin d'appuyer sur lecture à chaque verset. Le verset en cours de récitation est mis en surbrillance et la page défile avec la récitation.",
    "de": "Automatischer Sequenz-Player — Vers für Vers, Sure für Sure durch alle 114 Suren, ohne bei jedem Vers die Wiedergabetaste drücken zu müssen. Der aktuell rezitierte Vers wird hervorgehoben und die Seite scrollt mit der Rezitation mit.",
    "es": "Reproductor secuencial automático — versículo a versículo, sura a sura a través de las 114 suras, sin necesidad de presionar reproducir en cada versículo. El versículo que se está recitando se resalta y la página se desplaza siguiendo la recitación.",
    "ru": "Автоматический последовательный плеер — аят за аятом, сура за сурой через все 114 сур, без необходимости нажимать кнопку воспроизведения у каждого аята. Текущий читаемый аят выделяется, а страница прокручивается вслед за чтением.",
    "zh": "自动顺序播放器——逐节逐章，贯穿全部114章，无需在每节经文处手动按下播放键。正在诵读的经文将被高亮显示，页面随诵读自动滚动。",
    "ja": "自動連続再生プレーヤー — 全114スーラを一節ずつ、一スーラずつ順に再生し、各節ごとに再生ボタンを押す必要はありません。現在朗読中の節がハイライト表示され、ページが朗読に合わせてスクロールします。",
    "ko": "자동 순차 재생 플레이어 — 114개의 수라를 구절마다, 수라마다 순서대로 재생하며, 각 구절마다 재생 버튼을 누를 필요가 없습니다. 현재 낭독 중인 구절이 강조 표시되고 페이지가 낭독에 따라 스크롤됩니다.",
    "hi": "स्वचालित क्रमिक प्लेयर — आयत दर आयत, सूरह दर सूरह, सभी 114 सूरहों तक, हर आयत पर प्ले बटन दबाने की ज़रूरत नहीं। जो आयत पढ़ी जा रही है वह हाइलाइट होती है और पेज तिलावत के साथ-साथ स्क्रॉल होता है।"
  },
  "playAll": {
    "id": "Putar dari Al-Fatihah",
    "en": "Play from Al-Fatihah",
    "ar": "تشغيل من سورة الفاتحة",
    "fr": "Lire depuis Al-Fatihah",
    "de": "Abspielen ab Al-Fatihah",
    "es": "Reproducir desde Al-Fatihah",
    "ru": "Воспроизвести с Al-Fatihah",
    "zh": "从《开端章》开始播放",
    "ja": "アル＝ファーティハから再生",
    "ko": "알-파티하부터 재생",
    "hi": "अल-फ़ातिहा से चलाएं"
  },
  "resume": {
    "id": "Lanjutkan {surah} ayat {ayah}",
    "en": "Resume {surah} verse {ayah}",
    "ar": "استئناف {surah} الآية {ayah}",
    "fr": "Reprendre {surah} verset {ayah}",
    "de": "Fortfahren {surah} Vers {ayah}",
    "es": "Reanudar {surah} versículo {ayah}",
    "ru": "Продолжить {surah} аят {ayah}",
    "zh": "继续播放 {surah} 第 {ayah} 节",
    "ja": "{surah} 第{ayah}節から再開",
    "ko": "{surah} {ayah}절 이어서 재생",
    "hi": "{surah} आयत {ayah} से जारी रखें"
  },
  "playJuz": {
    "id": "Putar Juz",
    "en": "Play Juz",
    "ar": "تشغيل الجزء",
    "fr": "Lire le Juz",
    "de": "Juz abspielen",
    "es": "Reproducir Juz",
    "ru": "Воспроизвести Джуз",
    "zh": "播放篇章（Juz）",
    "ja": "ジュズを再生",
    "ko": "주즈 재생",
    "hi": "जुज़ चलाएं"
  },
  "juz": {
    "id": "Juz {n}",
    "en": "Juz {n}",
    "ar": "الجزء {n}",
    "fr": "Jouz {n}",
    "de": "Dschuz {n}",
    "es": "Yuz {n}",
    "ru": "Джуз {n}",
    "zh": "章节 {n}",
    "ja": "ジュズ {n}",
    "ko": "주즈 {n}",
    "hi": "जुज़ {n}"
  },
  "playSurah": {
    "id": "Putar surah ini",
    "en": "Play this surah",
    "ar": "تشغيل هذه السورة",
    "fr": "Lire cette sourate",
    "de": "Diese Sure abspielen",
    "es": "Reproducir esta surah",
    "ru": "Воспроизвести эту суру",
    "zh": "播放本章",
    "ja": "このスーラを再生する",
    "ko": "이 수라 재생",
    "hi": "यह सूरह चलाएं"
  },
  "playFromAyah": {
    "id": "Putar dari ayat ini",
    "en": "Play from this ayah",
    "ar": "تشغيل من هذه الآية",
    "fr": "Lire depuis ce verset",
    "de": "Ab diesem Vers abspielen",
    "es": "Reproducir desde este versículo",
    "ru": "Воспроизвести с этого аята",
    "zh": "从本节经文开始播放",
    "ja": "このアーヤから再生する",
    "ko": "이 아야부터 재생",
    "hi": "इस आयत से चलाएं"
  },
  "nowPlaying": {
    "id": "Sedang diputar",
    "en": "Now playing",
    "ar": "يُشغَّل الآن",
    "fr": "En cours de lecture",
    "de": "Wird jetzt abgespielt",
    "es": "Reproduciendo ahora",
    "ru": "Сейчас воспроизводится",
    "zh": "正在播放",
    "ja": "再生中",
    "ko": "지금 재생 중",
    "hi": "अभी चल रहा है"
  },
  "ayahOf": {
    "id": "Ayat {n}/{total}",
    "en": "Ayah {n}/{total}",
    "ar": "الآية {n}/{total}",
    "fr": "Verset {n}/{total}",
    "de": "Vers {n}/{total}",
    "es": "Versículo {n}/{total}",
    "ru": "Аят {n}/{total}",
    "zh": "第 {n}/{total} 节",
    "ja": "アーヤ {n}/{total}",
    "ko": "아야 {n}/{total}",
    "hi": "आयत {n}/{total}"
  },
  "prevAyah": {
    "id": "Ayat sebelumnya",
    "en": "Previous ayah",
    "ar": "الآية السابقة",
    "fr": "Verset précédent",
    "de": "Vorheriger Vers",
    "es": "Versículo anterior",
    "ru": "Предыдущий аят",
    "zh": "上一节",
    "ja": "前のアーヤ",
    "ko": "이전 아야",
    "hi": "पिछली आयत"
  },
  "nextAyah": {
    "id": "Ayat berikutnya",
    "en": "Next Verse",
    "ar": "الآية التالية",
    "fr": "Verset suivant",
    "de": "Nächster Vers",
    "es": "Versículo siguiente",
    "ru": "Следующий аят",
    "zh": "下一节经文",
    "ja": "次のアーヤ",
    "ko": "다음 구절",
    "hi": "अगली आयत"
  },
  "prevSurah": {
    "id": "Surah sebelumnya",
    "en": "Previous Surah",
    "ar": "السورة السابقة",
    "fr": "Sourate précédente",
    "de": "Vorherige Sure",
    "es": "Surah anterior",
    "ru": "Предыдущая сура",
    "zh": "上一章节",
    "ja": "前のスーラ",
    "ko": "이전 수라",
    "hi": "पिछली सूरह"
  },
  "nextSurah": {
    "id": "Surah berikutnya",
    "en": "Next Surah",
    "ar": "السورة التالية",
    "fr": "Sourate suivante",
    "de": "Nächste Sure",
    "es": "Surah siguiente",
    "ru": "Следующая сура",
    "zh": "下一章节",
    "ja": "次のスーラ",
    "ko": "다음 수라",
    "hi": "अगली सूरह"
  },
  "play": {
    "id": "Putar",
    "en": "Play",
    "ar": "تشغيل",
    "fr": "Lecture",
    "de": "Wiedergabe",
    "es": "Reproducir",
    "ru": "Воспроизвести",
    "zh": "播放",
    "ja": "再生",
    "ko": "재생",
    "hi": "चलाएं"
  },
  "pause": {
    "id": "Jeda",
    "en": "Pause",
    "ar": "إيقاف مؤقت",
    "fr": "Pause",
    "de": "Pause",
    "es": "Pausar",
    "ru": "Пауза",
    "zh": "暂停",
    "ja": "一時停止",
    "ko": "일시정지",
    "hi": "रोकें"
  },
  "stop": {
    "id": "Berhenti",
    "en": "Stop",
    "ar": "إيقاف",
    "fr": "Arrêt",
    "de": "Stopp",
    "es": "Detener",
    "ru": "Остановить",
    "zh": "停止",
    "ja": "停止",
    "ko": "정지",
    "hi": "बंद करें"
  },
  "speed": {
    "id": "Kecepatan",
    "en": "Speed",
    "ar": "السرعة",
    "fr": "Vitesse",
    "de": "Geschwindigkeit",
    "es": "Velocidad",
    "ru": "Скорость",
    "zh": "速度",
    "ja": "速度",
    "ko": "속도",
    "hi": "गति"
  },
  "repeatSurah": {
    "id": "Ulangi surah",
    "en": "Repeat surah",
    "ar": "تكرار السورة",
    "fr": "Répéter la sourate",
    "de": "Sure wiederholen",
    "es": "Repetir surah",
    "ru": "Повторить суру",
    "zh": "重复苏拉",
    "ja": "スーラを繰り返す",
    "ko": "수라 반복",
    "hi": "सूरह दोहराएं"
  },
  "autoNext": {
    "id": "Lanjut otomatis ke surah berikutnya",
    "en": "Auto-advance to the next surah",
    "ar": "الانتقال التلقائي إلى السورة التالية",
    "fr": "Passer automatiquement à la sourate suivante",
    "de": "Automatisch zur nächsten Sure wechseln",
    "es": "Avanzar automáticamente a la siguiente surah",
    "ru": "Автоматический переход к следующей суре",
    "zh": "自动切换到下一章苏拉",
    "ja": "次のスーラへ自動的に進む",
    "ko": "다음 수라로 자동 넘기기",
    "hi": "अगली सूरह पर स्वचालित रूप से आगे बढ़ें"
  },
  "openSurah": {
    "id": "Buka surah",
    "en": "Open surah",
    "ar": "فتح السورة",
    "fr": "Ouvrir la sourate",
    "de": "Sure öffnen",
    "es": "Abrir surah",
    "ru": "Открыть суру",
    "zh": "打开苏拉",
    "ja": "スーラを開く",
    "ko": "수라 열기",
    "hi": "सूरह खोलें"
  },
  "loading": {
    "id": "Memuat audio…",
    "en": "Loading audio…",
    "ar": "جارٍ تحميل الصوت…",
    "fr": "Chargement de l'audio…",
    "de": "Audio wird geladen…",
    "es": "Cargando audio…",
    "ru": "Загрузка аудио…",
    "zh": "正在加载音频…",
    "ja": "音声を読み込み中…",
    "ko": "오디오 불러오는 중…",
    "hi": "ऑडियो लोड हो रहा है…"
  },
  "error": {
    "id": "Audio tidak dapat dimuat. Periksa koneksi internet, lalu coba lagi.",
    "en": "Audio could not be loaded. Please check your internet connection and try again.",
    "ar": "تعذّر تحميل الصوت. يرجى التحقق من اتصالك بالإنترنت والمحاولة مجدداً.",
    "fr": "Impossible de charger l'audio. Veuillez vérifier votre connexion Internet, puis réessayer.",
    "de": "Audio konnte nicht geladen werden. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
    "es": "No se pudo cargar el audio. Por favor, comprueba tu conexión a Internet e inténtalo de nuevo.",
    "ru": "Не удалось загрузить аудио. Проверьте подключение к интернету и попробуйте снова.",
    "zh": "音频无法加载。请检查您的网络连接，然后重试。",
    "ja": "音声を読み込めませんでした。インターネット接続を確認して、もう一度お試しください。",
    "ko": "오디오를 불러올 수 없습니다. 인터넷 연결을 확인한 후 다시 시도해 주세요.",
    "hi": "ऑडियो लोड नहीं हो सका। कृपया अपना इंटरनेट कनेक्शन जांचें और पुनः प्रयास करें।"
  },
  "finished": {
    "id": "Alhamdulillah, khatam 114 surah.",
    "en": "Alhamdulillah, completed 114 surahs.",
    "ar": "الحمد لله، تمّت قراءة ١١٤ سورة.",
    "fr": "Alhamdulillah, 114 sourates complétées.",
    "de": "Alhamdulillah, 114 Suren abgeschlossen.",
    "es": "Alhamdulillah, completadas 114 suras.",
    "ru": "Альхамдулиллях, прочитано 114 сур.",
    "zh": "阿勒罕杜利拉，已完成114章。",
    "ja": "アルハムドゥリッラー、114章を完読しました。",
    "ko": "알함두릴라, 114개의 수라를 완독했습니다.",
    "hi": "अलहम्दुलिल्लाह, 114 सूरतें पूरी हुईं।"
  },
  "source": {
    "id": "Sumber audio: mp3quran.net",
    "en": "Audio source: mp3quran.net",
    "ar": "مصدر الصوت: mp3quran.net",
    "fr": "Source audio : mp3quran.net",
    "de": "Audioquelle: mp3quran.net",
    "es": "Fuente de audio: mp3quran.net",
    "ru": "Источник аудио: mp3quran.net",
    "zh": "音频来源：mp3quran.net",
    "ja": "音声ソース：mp3quran.net",
    "ko": "오디오 출처: mp3quran.net",
    "hi": "ऑडियो स्रोत: mp3quran.net"
  },
  "follow": {
    "id": "Ikuti bacaan",
    "en": "Follow the recitation",
    "ar": "تابع التلاوة",
    "fr": "Suivre la récitation",
    "de": "Der Rezitation folgen",
    "es": "Seguir la recitación",
    "ru": "Следить за чтением",
    "zh": "跟随诵读",
    "ja": "朗誦に従う",
    "ko": "낭독을 따라가기",
    "hi": "तिलावत का अनुसरण करें"
  },
  "qari": {
    "id": "Qari",
    "en": "Qari",
    "ar": "قارئ",
    "fr": "Qari",
    "de": "Qari",
    "es": "Qari",
    "ru": "Кари",
    "zh": "诵经者",
    "ja": "カーリ",
    "ko": "카리",
    "hi": "क़ारी"
  },
  "rewayat": {
    "id": "Riwayat Hafs 'an 'Ashim",
    "en": "Hafs 'an 'Ashim Narration",
    "ar": "رواية حفص عن عاصم",
    "fr": "Narration Hafs 'an 'Ashim",
    "de": "Hafs 'an 'Ashim Überlieferung",
    "es": "Narración Hafs 'an 'Ashim",
    "ru": "Риваят Хафс 'ан 'Асим",
    "zh": "哈芙斯传自阿西姆读法",
    "ja": "ハフス・アン・アーシム伝承",
    "ko": "하프스 안 아심 전승",
    "hi": "हफ्स 'अन 'आसिम रिवायत"
  },
  "sleepTimer": {
    "id": "Timer tidur",
    "en": "Sleep Timer",
    "ar": "مؤقت النوم",
    "fr": "Minuterie de sommeil",
    "de": "Schlaf-Timer",
    "es": "Temporizador de sueño",
    "ru": "Таймер сна",
    "zh": "睡眠定时器",
    "ja": "スリープタイマー",
    "ko": "수면 타이머",
    "hi": "स्लीप टाइमर"
  },
  "sleepOff": {
    "id": "Mati",
    "en": "Off",
    "ar": "إيقاف",
    "fr": "Désactivé",
    "de": "Aus",
    "es": "Apagado",
    "ru": "Выкл",
    "zh": "关闭",
    "ja": "オフ",
    "ko": "끄기",
    "hi": "बंद"
  },
  "sleepMin": {
    "id": "{n} menit",
    "en": "{n} minutes",
    "ar": "{n} دقيقة",
    "fr": "{n} minutes",
    "de": "{n} Minuten",
    "es": "{n} minutos",
    "ru": "{n} минут",
    "zh": "{n} 分钟",
    "ja": "{n} 分",
    "ko": "{n} 분",
    "hi": "{n} मिनट"
  },
  "sleepEndSurah": {
    "id": "Akhir surah",
    "en": "End of Surah",
    "ar": "نهاية السورة",
    "fr": "Fin de la sourate",
    "de": "Ende der Sure",
    "es": "Fin de la Surah",
    "ru": "Конец суры",
    "zh": "章节结束",
    "ja": "スーラの終わり",
    "ko": "수라 끝",
    "hi": "सूरह का अंत"
  },
  "sleepLeft": {
    "id": "Berhenti dalam {t}",
    "en": "Stop in {t}",
    "ar": "توقف خلال {t}",
    "fr": "Arrêt dans {t}",
    "de": "Stopp in {t}",
    "es": "Detener en {t}",
    "ru": "Остановка через {t}",
    "zh": "将在 {t} 后停止",
    "ja": "{t} 後に停止",
    "ko": "{t} 후 정지",
    "hi": "{t} में रुकेगा"
  },
  "sleepAtEnd": {
    "id": "Berhenti di akhir surah",
    "en": "Stop at the end of the surah",
    "ar": "توقف عند نهاية السورة",
    "fr": "Arrêt à la fin de la sourate",
    "de": "Stopp am Ende der Sure",
    "es": "Detener al final de la surah",
    "ru": "Остановка в конце суры",
    "zh": "在苏拉结束时停止",
    "ja": "スーラの終わりに停止",
    "ko": "수라 끝에 정지",
    "hi": "सूरह के अंत में रुकेगा"
  },
  "sleepDone": {
    "id": "Murottal dihentikan oleh timer tidur",
    "en": "Murottal stopped by sleep timer",
    "ar": "توقّف المرتّل بواسطة مؤقت النوم",
    "fr": "La récitation (Murottal) a été arrêtée par la minuterie de sommeil",
    "de": "Murottal wurde durch den Schlaf-Timer gestoppt",
    "es": "Murottal detenido por el temporizador de sueño",
    "ru": "Муроттал остановлен таймером сна",
    "zh": "穆罗特尔已被睡眠定时器停止",
    "ja": "ムロッタルはスリープタイマーによって停止されました",
    "ko": "무롯탈이 수면 타이머에 의해 정지되었습니다",
    "hi": "मुरोत्तल स्लीप टाइमर द्वारा रोका गया"
  },
  "reciterChanged": {
    "id": "Qari diganti: {name}",
    "en": "Reciter changed: {name}",
    "ar": "تم تغيير القارئ: {name}",
    "fr": "Récitateur modifié : {name}",
    "de": "Rezitator geändert: {name}",
    "es": "Recitador cambiado: {name}",
    "ru": "Чтец изменён: {name}",
    "zh": "诵读者已更换：{name}",
    "ja": "読誦者が変更されました：{name}",
    "ko": "낭송자가 변경되었습니다: {name}",
    "hi": "क़ारी बदला गया: {name}"
  }
};
